import { $ } from "../../third-party-imports";
import { titleCase } from "../../util";

export function updateBlogResultText(totalCount: any, category: any, tag: any, content: any)
{
    const blogSearchResultText = $('.cat_result').find('p');
    const value = blogSearchResultText.html();

    // if ((category === 'none' && !content && !tag) || !totalCount ) {
    //     blogSearchResultText.html('');
    //     return;
    // }
    let updatedText;
    let otherKeywordHTML = '<p class="blue-bold-regular-text d-none">Try using other keywords that are related to your search.</p>';
    category = titleCase(category);
    if (category.toLowerCase() !== 'none' && totalCount > 0)
    {
        updatedText = value.replace('0', totalCount).replace('Be Ready', category);
    } else if (category.toLowerCase() !== 'none' && totalCount === 0)
    {
        updatedText = value.replace('0', totalCount).replace('Be Ready', category);
        $($(".cat_result")[0]).append(otherKeywordHTML);
    }

    if (content && totalCount > 0)
    {
        updatedText = value.replace('0', totalCount).replace('for Category: Be Ready', `for Search: ${content}`);
    } else if (content && totalCount === 0)
    {
        updatedText = value.replace('0', totalCount).replace('for Category: Be Ready', `for Search: ${content}`);
        $($(".cat_result")[0]).append(otherKeywordHTML);
    }

    if (tag && totalCount > 0)
    {
        updatedText = value.replace('0', totalCount).replace('for Category: Be Ready', `for Tag: ${tag}`);
    } else if (tag && totalCount === 0)
    {
        updatedText = value.replace('0', totalCount).replace('for Category: Be Ready', `for Tag: ${tag}`);
        $($(".cat_result")[0]).append(otherKeywordHTML);
    }

    if (category.toLowerCase() === 'none' && tag === "" && content === "" && totalCount > 0)
    {
        blogSearchResultText.html('');
        return;
    }

    blogSearchResultText.html(updatedText);
    $('.cat_result').find('p').toggleClass('d-none d-block');
}
